import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@design-system/i18n';
import { SimpleCard } from '@design-system/simple-card';
export const DefaultEmptyState = ({ clearFilters, noResultsMessage }) => {
    const { __ } = useI18n();
    return (_jsx(SimpleCard, { buttonProps: {
            dataTestId: 'no-matches-filters-clear',
            onClick: clearFilters,
            size: 'large',
            children: __('Clear all filters'),
        }, description: __('Clear your filters or try again with different search criteria'), faIconProps: { iconName: 'megaphone' }, title: noResultsMessage !== null && noResultsMessage !== void 0 ? noResultsMessage : __('No matches found') }));
};
//# sourceMappingURL=index.js.map